import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

type NotificationPhones = { phones: string[] };
type TestNotificationResult = { ok: boolean; sent?: number; reason?: string };

export function useWhatsAppNotificationPhones() {
  return useQuery({
    queryKey: ["whatsapp-notification-phones"],
    queryFn: () => api.get<NotificationPhones>("/crm/whatsapp/notification-phones"),
  });
}

export function useSaveNotificationPhones() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (phones: string[]) =>
      api.put<NotificationPhones>("/crm/whatsapp/notification-phones", { phones }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["whatsapp-notification-phones"] });
      toast.success("Lista guardada");
    },
  });
}

export function useSendTestNotification() {
  return useMutation({
    mutationFn: () => api.post<TestNotificationResult>("/crm/whatsapp/test-notification", {}),
    onSuccess: (result) => {
      if (result.ok) {
        toast.success(`Notificación enviada a ${result.sent ?? 0} teléfonos`);
      } else {
        toast.error(`No se pudo enviar: ${result.reason ?? "error desconocido"}`);
      }
    },
    onError: () => {
      toast.error("Error al enviar la notificación de prueba");
    },
  });
}
